import React, { useMemo } from 'react'
import { FormCheck } from 'react-bootstrap'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { openIdentityPdfModalDialog } from '../../../actions/pdf_modal_dialog'
import { openSrcLightbox } from '../../../actions/src_lightbox'
import { DOCUMENT_TYPE_PDF } from '../../../config'
import { detectDocumentTypeInUrl } from '../../../utils/filters'
import { getPdfFileName, savePdf } from '../../../utils/pdf'

const TablePdfVerificationDocs = (props) => {
  const { openIdentityPdfModalDialog, openSrcLightbox, data } = props
  const onDocumentClick = (entity) => (event) => {
    if (event.target.checked) {
      props.selectDocument(entity.id)
    } else {
      props.unselectDocument(entity.id)
    }
  }

  const isPdf = (document) => detectDocumentTypeInUrl(document) === DOCUMENT_TYPE_PDF

  const isVerified = (entity) => entity.status === 'verified'

  const result = useMemo(() => {
    return data.map((entity, i) => {
      if (entity.id) {
        let handleClick, faIconClass
        let downloadPdf = null
        if (entity.document && isPdf(entity.document.document)) {
          downloadPdf = (
            <span
              onClick={() => savePdf(entity.document.document, getPdfFileName(entity.document.document))}
              className='cursor-pointer m-l-sm'
            >
              <i className='fa fa-download fa-2x' title='Download Document' />
            </span>
          )
          faIconClass = 'fa fa-file-pdf-o fa-2x cursor-pointer'
          handleClick = () => openIdentityPdfModalDialog(entity.document)
        } else {
          handleClick = () => openSrcLightbox(entity.document.document)
          faIconClass = 'fa fa-file-image-o fa-2x cursor-pointer'
        }
        return (
          <td key={i}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className={faIconClass} aria-hidden='true' onClick={handleClick} title='View Document' />
              <div className={'m-l-sm'}>{downloadPdf}</div>
              <div style={{ marginLeft: 10, textAlign: 'center' }}>
                <FormCheck
                  title='Document Verified'
                  defaultChecked={isVerified(entity)}
                  disabled={isVerified(entity) || props.verified}
                  onClick={onDocumentClick(entity)}
                />
              </div>
            </div>
          </td>
        )
      }
      return null
    })
  }, [data, openIdentityPdfModalDialog, openSrcLightbox])

  return result ? <tr>{result}</tr> : null
}

const mapStateToProps = (state) => ({
  isModalDialogOpen: state.identityPdfModalDialog.isModalDialogOpen,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openIdentityPdfModalDialog,
      openSrcLightbox,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(TablePdfVerificationDocs)
